import script from "./OverviewPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewPanel.vue?vue&type=script&setup=true&lang=js"

import "./OverviewPanel.vue?vue&type=style&index=0&id=dbcf5f2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbcf5f2c"]])

export default __exports__